// Fonctions de validation pour les formulaires

export const validateStep1 = (selectedType) => {
  const errors = {};

  if (!selectedType) {
    errors.type = 'Veuillez sélectionner un type d\'utilisateur.';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[0-9+\-\s()]+$/;
  return phoneRegex.test(phone) && phone.length >= 10;
};

export const validateRequired = (value) => {
  return value && value.trim() !== '';
};

export const validateDate = (dateString) => {
      console.log('validateDate - dateString reçu:', dateString, 'type:', typeof dateString);
  if (!dateString || typeof dateString !== 'string') {
    console.log('validateDate - dateString invalide (null, undefined ou pas string)');
    return false;
  }
  const date = new Date(dateString);
  const isValidDate = !isNaN(date.getTime());
  const matchesFormat = dateString.match(/^\d{4}-\d{2}-\d{2}$/);
  console.log('validateDate - date object:', date, 'isValidDate:', isValidDate, 'matchesFormat:', matchesFormat);
  return isValidDate && matchesFormat;
};

export const validateAge = (dateString, minAge = 18, maxAge = 100) => {
  console.log('validateAge - dateString:', dateString, 'minAge:', minAge, 'maxAge:', maxAge);
  if (!validateDate(dateString)) {
    console.log('validateAge - validateDate a échoué');
    return false;
  }
  const birthDate = new Date(dateString);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age;
  console.log('validateAge - birthDate:', birthDate, 'today:', today, 'calculated age:', actualAge);
  const isValidAge = actualAge >= minAge && actualAge <= maxAge;
  console.log('validateAge - isValidAge:', isValidAge);
  return isValidAge;
};

export const validateStep2 = (formData) => {
  const errors = {};

  if (!validateRequired(formData.nom)) {
    errors.nom = 'Le nom est obligatoire.';
  }

  // prenoms optional
  // if (!validateRequired(formData.prenoms)) {
  //   errors.prenoms = 'Les prénoms sont obligatoires.';
  // }

  if (!validateRequired(formData.email) || !validateEmail(formData.email)) {
    errors.email = 'Un email valide est obligatoire.';
  }

  if (!validateRequired(formData.telephone) || !validatePhone(formData.telephone)) {
    errors.telephone = 'Un numéro de téléphone valide est obligatoire.';
  }

  if (!validateRequired(formData.adresse)) {
    errors.adresse = 'L\'adresse est obligatoire.';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateStep3Famille = (hasSpouse, spouse, numberOfChildren, children) => {
  const errors = {};

  // Validation des dates de naissance supprimée car elles viennent de l'API

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateStep4 = (principalDob, answers) => {
  console.log('validateStep4 - principalDob reçu:', principalDob);
  const errors = {};

  if (!validateDate(principalDob)) {
    console.log('validateStep4 - validateDate a échoué');
    errors.principalDob = 'Date de naissance invalide.';
  } else if (!validateAge(principalDob, 18, 65)) {
    console.log('validateStep4 - validateAge a échoué');
    errors.principalDob = 'Date de naissance invalide ou âge non conforme (18-65 ans).';
  } else {
    console.log('validateStep4 - Validation date réussie');
  }

  // Add validations for required medical questions if any

  console.log('validateStep4 - Erreurs finales:', errors);
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};